import React, { Fragment, useEffect, useRef, useState } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { showToast } from "../../../components/ToastifyNotification";
import { useNavigate } from "react-router-dom";
import { ChangePassword } from "../../../api/messaging/passwordChangeAPI";
import { useSelector } from "react-redux";
import useKeyboardSubmit from "../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../hooks/useEnterNavigation";

/* -------------------------
   VALIDATION SCHEMA
--------------------------*/
const schema = yup.object().shape({
  oldPassword: yup.string().required("Old password is required"),
  password: yup
    .string()
    .min(4, "Password must be at least 4 characters")
    .required("New password is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required")
});

const PasswordChange = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");

  const user = useSelector(state => state?.authReducer?.user || {});

  useEffect(() => {
    setUsername(user?.userName);
  }, [user]);

  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await ChangePassword(data);

      if (response.success) {
        showToast("success", response.message);
        reset();
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error.message || "Something went wrong");
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
        useKeyboardSubmit(handleSubmit, onSubmit);
        useEnterNavigation(formRef);

  return (
    <Fragment>
      <Breadcrumb parent="Account" title="Change Password" />

      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="card shadow-sm">
              <div className="card-header">
                <h5 className="mb-0">Change Password</h5>
              </div>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="card-body">
                  <div className="form-group mb-3">
                    <label className="form-label">Username</label>
                    <input
                      type="text"
                      className="form-control"
                      value={username}
                      readOnly
                      />
                  </div>
                  {/* OLD PASSWORD */}
                  <div className="form-group mb-3">
                    <label className="form-label">Old Password</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Enter old password"
                      {...register("oldPassword")}
                    />
                    {errors.oldPassword &&
                      <small className="text-danger">
                        {errors.oldPassword.message}
                      </small>}
                  </div>

                  {/* NEW PASSWORD */}
                  <div className="form-group mb-3">
                    <label className="form-label">New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Enter new password"
                      {...register("password")}
                    />
                    {errors.password &&
                      <small className="text-danger">
                        {errors.password.message}
                      </small>}
                  </div>

                  {/* CONFIRM PASSWORD */}
                  <div className="form-group mb-3">
                    <label className="form-label">Confirm Password</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Confirm new password"
                      {...register("confirmPassword")}
                    />
                    {errors.confirmPassword &&
                      <small className="text-danger">
                        {errors.confirmPassword.message}
                      </small>}
                  </div>
                </div>

                {/* FOOTER */}
                <div className="card-footer d-flex justify-content-between">
                  <button type="submit" className="btn btn-primary px-4">
                    Change Password
                  </button>

                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PasswordChange;
